import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'brainloper-ui';

export interface Theme {
  name: string;
  className: string;
  isDark: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private activeThemeSubject = new BehaviorSubject<Theme>(null);
  activeTheme$ = this.activeThemeSubject.asObservable();

  availableThemes: Theme[] = [
    { name: 'Claro', className: 'fosil-light-theme', isDark: false },
    { name: 'Oscuro', className: 'fosil-dark-theme', isDark: true }
  ];

  constructor(
    private rendererFactory: RendererFactory2,
    private storage: LocalStorageService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.initTheme();
  }

  private initTheme() {
    const savedThemeClass = this.storage.get<string>('activeTheme');
    const theme = this.availableThemes.find(t => t.className === savedThemeClass) || this.availableThemes[0];
    this.setTheme(theme);
  }

  setTheme(theme: Theme) {
    const currentTheme = this.activeThemeSubject.value;
    if (currentTheme) {
      this.renderer.removeClass(document.body, currentTheme.className);
    }
    
    this.renderer.addClass(document.body, theme.className);
    this.activeThemeSubject.next(theme);
    this.storage.set('activeTheme', theme.className);
  }

  getAvailableThemes(): Theme[] {
    return this.availableThemes;
  }
}
